/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "variant_default": "flex flex-row order-1 items-center whitespace-nowrap before:block before:order-2 after:block after:order-3 after:bg-[url(\"/image/femina-logo-red.svg\")] after:bg-no-repeat",
  "colors_default": "before:bg-linen-300",
  "size_default": "text-headline-xl m-6 gap-3 after:h-6 after:w-100 sm:after:w-40 md:after:w-32 before:w-full before:h-0.25"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "NoInfinityTeaserBoxTitle");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;